import React from 'react';
import {
    azureStorageAccounts,
    clearUrlParamsIfChanged,
    clearShowAction,
    updateUrlParams,
    wizardStepStarted,
    wizardStepExited
} from '../../../store/wizard/action_creators';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import ServerStepTemplate from "./ServerStepTemplateNew";
import {
    END_POINT_NAMES_MAP,
} from '../../../consts';
import {
    getPropFromState,
    getWizardParamsFromWizardState
} from '../../../utils/mapStateToPropsUtils';
import { validate } from "./additionalSettings/validators/azureValidatorNew";
import useStepinize from "../useStepinize";
import AzureAdditionalSettings from "./additionalSettings/AzureAdditionalSettingsNew";
import azureDefaultSvg from "../../../assets/svgs/azure-default.svg?url";

const loading = () => { return { text: END_POINT_NAMES_MAP.AZURE, icon: azureDefaultSvg } }
const stepId = ({ isTargetStepFromSameSourceType }) => {
    return isTargetStepFromSameSourceType ? 'targetAzureBlob' : 'azureBlob';
};

const fetchData = ({ azureStorageAccounts }) => {
    azureStorageAccounts();
};
const shouldFetch = (props) => {
    return !props._azureStorageAccounts || !props._azureStorageAccounts.succeeded;
};
const isFetching = ({ _azureStorageAccounts }) => _azureStorageAccounts.inProgress || !_azureStorageAccounts.data;

const AzureBlobStep = (props) => {
    const { LoadingComp, moreStepInfo } = useStepinize({ props, fetchData, shouldFetch, loading, stepId })
    const { isTargetStepFromSameSourceType, isSourceStep } = moreStepInfo;

    const { _azureStorageAccounts, _wizard, _ui: { azure }, state, clearSelectedParams } = props;
    const { selectedWizardParams: { selectedStorageAccountName, selectedStorageAccountNameTarget } } = _wizard;
    const selectedServer = isTargetStepFromSameSourceType ? selectedStorageAccountNameTarget : selectedStorageAccountName;
    const stateParamsToClear = isTargetStepFromSameSourceType ? ["azureBlobContainerPathTarget"] : ["azureBlobContainerPath"];

    const stepOptions = {
        storage: _azureStorageAccounts,
        server: selectedServer,
        serverSVG: "azure-default.svg",
        step: azure ? azure.step : "ip",
        serverType: "Azure",
        serverTitle: "Azure",
        selectType: "Storage Account",
        serverPlaceholder: "",
        title: `Select an ${END_POINT_NAMES_MAP.AZURE} ${isSourceStep ? "Source" : "Target"}`,
        changeServerTitle: "Change Azure Storage Account",
        clearShowOptions: { keyToClear: ['_showAzureBlobContainers', selectedServer] },
        validate,
        SecondScreenUi: AzureAdditionalSettings,
        shouldGoToSecondScreen: () => true,
        stateParamsToClear,
        getSelectedParams: (host) => {
            const hostParam = isTargetStepFromSameSourceType ? 'storageAccountNameTarget' : 'storageAccountName';
            if ((state[hostParam] && state[hostParam] !== host)) {
                clearSelectedParams(stateParamsToClear)
            }
            return {
                [hostParam]: host
            }
        }

    };

    return isFetching({ ...props, ...moreStepInfo }) ? LoadingComp : <ServerStepTemplate stepOptions={stepOptions} {...props} {...moreStepInfo} />;
};

let AzureBloblStepForm = reduxForm({
    form: 'azureBlob',
    validate,
    shouldError: () => true
})(AzureBlobStep);

const selector = formValueSelector('azureBlob');
AzureBloblStepForm = connect(
    (state) => ({
        copyAcl: selector(state, "copyAcl")
    })
)(AzureBloblStepForm);

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        _wizard: getWizardParamsFromWizardState(state, ownProps, ownProps.state)._wizard,
        _azureStorageAccounts: getPropFromState(state, "_azureStorageAccounts", {}),
        _relationships: getPropFromState(state, "_relationships", {}),
        _ui: { ...state.syncReducer._ui, ...state.global._ui },
        routing: state.router,
    }
};

const mapDispatchToProps = {
    azureStorageAccounts,
    clearUrlParamsIfChanged,
    clearShowAction,
    updateUrlParams,
    wizardStepStarted,
    wizardStepExited
};

export default connect(mapStateToProps, mapDispatchToProps)(AzureBloblStepForm);
